import React from "react";
import LoaderGif from "../../assets/Logo.png";

const Loader = () => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-[#090c18]">
      <img
        src={LoaderGif}
        alt="Loading..."
        className="animate-pulse"
        width={100}
        height={100}
      />
    </div>
  );
};

export default Loader;
